import React from 'react';
import { styled } from '@mui/material/styles';
import CloseIcon from '../../../icons/CloseIcon';
import useChatContext from '../../../hooks/useChatContext/useChatContext';

const Container = styled('div')({
  height: '56px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0 1em',
});

const HeaderText = styled('div')({
  color: '#10416D',
  fontWeight: 'bold',
  textTransform: 'uppercase',
});

const CloseButton = styled('button')({
  cursor: 'pointer',
  display: 'flex',
  background: 'transparent',
  border: '0',
  padding: '0.4em',
});

export default function ChatWindowHeader() {
  const { setIsChatWindowOpen } = useChatContext();

  return (
    <Container>
      <HeaderText>Chat</HeaderText>
      <CloseButton onClick={() => setIsChatWindowOpen(false)}>
        <CloseIcon />
      </CloseButton>
    </Container>
  );
}
